<template>
  <v-main>
    <h2>Password & Security</h2>
    <v-container class="mt-4">
    <p>Tap the button below to reset your password</p>
      <v-form class="mb-3">
        <v-text-field
          color="black"
          style="color:black;border-radius:15px;height:56px;background:white;border-color:black"
          outlined
          label="Email"
          v-model="email"
          class="black--text mb-4"
          prepend-inner-icon="mdi-email"
          readonly
        />
      </v-form>
      <div class="white--text mt-9">
        <v-btn
          x-large
          block
          style="border-radius:12px"
          class="white--text"
          color="#e00000"
          @click="updatePassword"
          :loading="loading"
          >Reset Password</v-btn
        >
      </div>
    </v-container>
  </v-main>
</template>

<script>
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

export default {
  data() {
    return {};
  },

  props: {
    email: {
      type: String,
    },
  },

  methods: {
    updatePassword() {
    this.loading=true
      const auth = getAuth();
      sendPasswordResetEmail(auth, this.email)
        .then(() => {
            this.loading = false
          this.$swal({
          title: "Email Sent Succesfully!",
          text: "Kindly check your email, click the link to change your password",
          icon: "success",
          confirmButtonText: "Ok!",
        });
        })
        .catch((error) => {
    this.loading = false
        this.$swal({
          title: "Something went wrong!",
          text: "Sorry, we could not send you a reset email because"+""+error.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
         
        });
    },
  },
};
</script>
